import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { SearchRequest } from '../../common/models/dto/search-request';
import { StatoEntita } from '../../common/models/tipologiche/stato-entita';
import { ServicePathsSettings } from '../../core/configuration/service-paths-settings';
import { OperationsUrlSettingsSearch } from '../configuration/operations-url-settings-search';
import { SearchAdempimentiRequest } from 'src/app/common/models/dto/adempimenti-search';

@Injectable()
export class ServicesSearch {
  constructor(private http: HttpClient) {}

  ricercaCompletataObservable = new BehaviorSubject<boolean>(false);
  private handleError(error: HttpResponse < any > | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error = new HttpResponse < any > ()) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = '${error.status} - ${error.statusText || ""} ${err}';
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return throwError(errMsg);
  }



  search(searchRequest: SearchRequest): Observable < any > {
    return this.http.post(ServicePathsSettings.DOMINIO + OperationsUrlSettingsSearch.URL_POST_SEARCH, searchRequest)
  }

  searchPrecedentiCorrelate(searchRequest: SearchRequest): Observable < any > {
    return this.http.post(ServicePathsSettings.DOMINIO + OperationsUrlSettingsSearch.URL_POST_SEARCH_PRECEDENTI_CORRELATE, searchRequest)
  }

  // Recupera se presenti i valori TLF_USER e TLF_SDOMAIN dal localstorage e restituisce gli headers
  ottieniHeader(): Headers {

    const headers = new Headers();

    const smUser = localStorage.getItem('TLF_USER');
    // const smDomain = localStorage.getItem("TLF_SDOMAIN");
    const smTeleforum = 'teleforum';
    const smTenant = localStorage.getItem('TLF_TENANT');

    if(smUser /*&& smDomain*/){
      headers.append('TLF_USER', smUser);
      // headers.append('TLF_SDOMAIN', smDomain);
      headers.append('TLF_PRODUCT', smTeleforum);
      headers.append('TLF_TENANT', smTenant);
    }

    return headers;
  }

  smartSearch(queryParam: String): Observable < any > {
    return this.http.post(ServicePathsSettings.DOMINIO_API_GATEWAY +  OperationsUrlSettingsSearch.URL_SMART_SEARCH,
      {testo : queryParam}
      );
  }

  searchFaccetteGlobali(): Observable < any > {
    return this.http.get(ServicePathsSettings.DOMINIO + OperationsUrlSettingsSearch.URL_POST_SEARCH_FACCETTE_GLOBALI)
  }

  searchRiuniti(searchRequest: SearchRequest): Observable < any > {
    return this.http.post(ServicePathsSettings.DOMINIO + OperationsUrlSettingsSearch.URL_SEARCH_RIUNITI, searchRequest)
  }

  searchAdempimenti(request: SearchAdempimentiRequest): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_SEARCH_ADEMPIMENTI, request);
    return response;
  }

  searchAtti(request: SearchRequest): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_SEARCH_ATTI, request);
    return response;
  }

  getParametriCriteriUtenteRicerca(): Observable < any > {
    return this.http.get(ServicePathsSettings.DOMINIO_API_GATEWAY + OperationsUrlSettingsSearch.URL_GET_CRITERI_UTENTE_RICERCA)
  }

  getParametriCriteriUtenteEstrazioneDati(): Observable < any > {
    return this.http.get(ServicePathsSettings.DOMINIO_API_GATEWAY + OperationsUrlSettingsSearch.URL_GET_CRITERI_UTENTE_ESTRAZIONE_DATI)
  }

  getParametriCriteriUtenteEstrazioneDatiCd(): Observable < any > {
    return this.http.get(ServicePathsSettings.DOMINIO_API_GATEWAY + OperationsUrlSettingsSearch.URL_GET_CRITERI_UTENTE_ESTRAZIONE_DATI_CD)
  }

  getComboValues(urlPath: string): Observable < any > {
    return this.http.get(ServicePathsSettings.DOMINIO + urlPath)
  }

  getComboValuesByLovData(lovData: string): StatoEntita[] {
    const result: StatoEntita[] = [];
    const options: string[] = lovData.split(';');
    for (const optionString of options) {
      const option: string[] = optionString.split(':');
      const statoEntita = new StatoEntita();
      statoEntita.id = option[1];
      statoEntita.label = option[0];
      statoEntita.descrizione = option[0];
      result.push(statoEntita);
    }
    return result;
  }

  notifyRicercaCompletata() {
    this.ricercaCompletataObservable.next(true);
  }


  listTemplates(location: string): Observable < any > {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.LIST_TEMPLATES.replace('{location}', location));
  }
}
